import { combineReducers } from '@reduxjs/toolkit';
import productsAndServicesReducer from './productAndServiceDataReducer';

const rootReducer = combineReducers({
    productsAndServicesData: productsAndServicesReducer
});

export default rootReducer;
